module.exports = __webpack_public_path__ + "media/Raven_Red_Blue.23.4b2670a7.mp4";